// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2bijt","title":"Info_title__2aCCn","links":"Info_links__2RP3I","link":"Info_link__2JtVJ","logo":"Info_logo__3XYNk"};